












































import { Component, Vue, Model, Prop } from 'vue-property-decorator';
import qiniuUpload from './qiniuupload';
import _ from 'lodash';

@Component
export default class MultiImgUpload extends Vue {
  @Model('change', { type: Object })
  readonly fileList !: Array<{
    name: string;
    url: string;
  }>;
  @Prop()
  limit!: number;

  dialogImageUrl = '';
  dialogVisible = false;
  disabled = false;

  uploadFile(options: any) {
    return qiniuUpload(options).then((file) => {
      this.$emit('change', [
        ...this.fileList,
        file,
      ])
    });
  }

  handlePictureCardPreview(file: any) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }
  handleDownload(file: any) {
    console.log(file);
  }
  handleRemove(file: any) {

  }
  handleExceed(files: Array<any>, fileList: Array<any>) {
    this.$message.warning(`当前限制选择 ${_.get(this.$attrs, 'limit', 0)} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
  }
}
